// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-hamburger_root__Tz99H","bar":"menu-hamburger_bar__sgCBo","open":"menu-hamburger_open___tKqq","searchPage":"menu-hamburger_searchPage__DCIIJ"};